import React from 'react';
import { Box, Typography, TextField, Button, Alert } from '@mui/material';
import { VideoCall } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface PreJoinScreenProps {
  roomName: string;
  onRoomNameChange: (name: string) => void;
  onJoinRoom: () => void;
  error: string | null;
  onClearError: () => void;
}

export const PreJoinScreen: React.FC<PreJoinScreenProps> = ({
  roomName,
  onRoomNameChange,
  onJoinRoom,
  error,
  onClearError,
}) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Box maxWidth={400} width="100%" p={3}>
        <Typography variant="h4" gutterBottom align="center">
          {t('Join Room')}
        </Typography>

        <Box mb={2}>
          <Typography variant="body1" gutterBottom>
            {t('Room Name')}
          </Typography>
          <TextField
            fullWidth
            value={roomName}
            onChange={(e) => onRoomNameChange(e.target.value)}
            placeholder={t('Enter room name')}
            variant="outlined"
          />
        </Box>

        <Box display="flex" gap={2} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<VideoCall />}
            onClick={onJoinRoom}
            disabled={!roomName.trim()}
          >
            {t('Join Room')}
          </Button>
        </Box>

        {error && (
          <Box mt={2}>
            <Alert severity="error" onClose={onClearError}>
              {t(error)}
            </Alert>
          </Box>
        )}
      </Box>
    </Box>
  );
};
